import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Router} from '@angular/router';
import {PersonLogin} from '../person/person-login';
import {OrganizationContactService} from '../services/organization-contact-service';
import {PersonLoginService} from '../services/person-login-service';
import {StringUtils} from '../utils/string-utils';
import {OrganizationContact} from './organization-contact';
import {MatProgressSpinner} from '@angular/material/progress-spinner';


@Component({
    selector: 'myContacts',
    templateUrl: './my-contacts.component.html',
    styleUrls: ['./my-contacts.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner]
})
export class MyContactsComponent implements OnInit {
  private readonly personLoginService = inject(PersonLoginService);
  private readonly organizationContactService = inject(OrganizationContactService);
  private readonly router = inject(Router);


  private personLogin!: PersonLogin;
  public readonly contacts = signal<OrganizationContact[]>(undefined!);
  public readonly isBusy = signal<boolean>(undefined!);
  public readonly errorMessage = signal<string>(undefined!);
  public readonly searchComplete = signal<boolean>(undefined!);

  ngOnInit(): void {
    if (this.personLoginService.isOutsideEngineer()) {
      this.router.navigate(['ratings']);
    } else {
      this.personLogin = this.personLoginService.getCachedLogin()!;
      this.search();
    }
  }

  public search(): void {
    this.clearStatus();
    this.organizationContactService.getOrganizationContacts(this.personLogin.person.primaryOrgUnitId).subscribe(results => {
      this.contacts.set(results);
      this.isBusy.set(false);
      this.searchComplete.set(true);
    }, error => this.handleError(error));
  }

  private clearStatus(): void {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.searchComplete.set(false);
    this.contacts.set(null!);
  }

  private handleError(error: any): void {
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }
}

